module.exports = __webpack_public_path__ + "img/hero-1-bg-img.6fa0e0e7.png";